import * as React from 'react'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { adminService } from '../../../../core/services'
import { InputText } from '../../../atoms'
import AdminLayoutNew from '../_layouts/new'
import * as interfaces from '../../../../static/interfaces'
import styled from 'styled-components'
import * as constants from '../../../../static/constants'

declare var window: interfaces.IWindow

interface IProps {
  display_languages: IJsonResponse
}

const FIELDS = {
  name: 'name',
  post_id: 'post_id',
  display_language_id: 'display_language_id',
}

const title = I18n.t('admin.create_new', {
  model: I18n.t('pickup', { scope: 'activerecord.models' }),
})

const searchPost = async (baseParams, newTitle) => {
  const params = { ...baseParams }
  if (newTitle) {
    params.keywords = newTitle
  }
  return adminService.searchPost(params)
}

const getPostByID = async id => {
  return adminService.getPostById(id)
}

const AdminPickupNew: React.FC<IProps> = props => {
  const { data: display_languages } = adminService.getDataFromJson(props.display_languages)
  const urlParams = new URLSearchParams(window.location.search)
  const display_language_id = urlParams.get('display_language_id') || display_languages[0].id
  const handleSubmit = React.useCallback(async (initialValues, values) => {
    const { createdPickup, flush } = await adminService.createPickup(values)
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    location.href = `/admin/pickups?display_language_id=${createdPickup.display_language_id}`
  }, [])

  const [postData, setPostData] = React.useState({
    postTitle: '',
    postId: '',
  })

  const [noPostWithThisId, setNoPostWithThisId] = React.useState<boolean>(false)

  const getPostData = React.useCallback(async (name, value) => {
    if (name === 'search') {
      const filterParams = []
      const result = await searchPost({ ...filterParams }, value)
      if (result.posts[0] !== undefined) {
        const newPostData = { ...postData }
        newPostData.postTitle = result.posts[0].name
        newPostData.postId = result.posts[0].id
        setPostData(newPostData)
        setNoPostWithThisId(false)
      } else {
        setPostData({ postId: '', postTitle: '' })
      }
    } else if (name === 'post_id') {
      const result = await getPostByID(value)
      if (result.post !== undefined) {
        const newPostData = { ...postData }
        newPostData.postTitle = result.post.name
        newPostData.postId = value
        setPostData(newPostData)
        setNoPostWithThisId(false)
      } else {
        setPostData({ postId: value, postTitle: '' })
        setNoPostWithThisId(true)
      }
    }
  }, [])

  const searchPostData = React.useCallback(event => {
    if (event.target.value.trim() !== '') {
      getPostData(event.target.name, event.target.value)
    } else {
      setPostData({ postId: '', postTitle: '' })
    }
  }, [])

  return (
    <AdminLayoutNew
      model="pickup"
      title={title}
      fields={FIELDS}
      indexLink={`/admin/pickups?display_language_id=${display_language_id}`}
      formItems={
        <>
          <InputText
            onChangeHandler={searchPostData}
            required={false}
            name="search"
            defaultValue=""
            label={I18n.t('generic.search_by_tour_name')}
          />

          <InputTextWrapper className="InputText">
            <p className="InputText_Title">{I18n.t('generic.post_id')}</p>
            <div className="InputText_Main">
              <input
                onChange={searchPostData}
                required={true}
                name="post_id"
                value={postData.postId}
              />
            </div>
          </InputTextWrapper>
          {noPostWithThisId === true && <div>No Tour with this ID</div>}
          <InputText
            readonly={true}
            required={false}
            name="name"
            defaultValue={postData.postTitle}
            label={I18n.t('generic.name')}
          />
          <InputText
            readonly={true}
            name="display_language_name"
            defaultValue={
              display_languages.find(
                display_language => display_language.id === Number(display_language_id)
              ).name_i18n
            }
            label={I18n.t('post.display_language')}
          />
          <DispayLanguageIdWrapper>
            <InputText
              readonly={true}
              name="display_language_id"
              defaultValue={display_language_id}
              label={I18n.t('post.display_language')}
            />
          </DispayLanguageIdWrapper>
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

const InputTextWrapper = styled.div`
  display: flex;

  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    flex-direction: column;
  }

  input {
    display: block;
    width: 100%;
    padding: 8px 12px;
    border: solid 1px ${constants.COLORS.divider};
    border-radius: 4px;
    font-size: 15px;
    transition: border 0.2s ease;
    outline: none;
    background: none;

    &:not([readonly]):focus {
      border: solid 1px ${constants.COLORS.primary};
    }
  }

  input[readonly] {
    background-color: ${constants.COLORS.divider};
  }

  .InputText_Title {
    width: 240px;
    margin-top: 8px;
    font-size: 15px;
    font-weight: bold;
    line-height: 1;

    @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      width: 100%;
      margin-bottom: 12px;
    }
  }

  .InputText_Required {
    display: inline-block;
    border-radius: 3px;
    color: ${constants.COLORS.white};
    background-color: ${constants.COLORS.caution};
    vertical-align: middle;
    font-size: 11px;
    font-weight: normal;
    padding: 4px 6px;
    margin-left: 8px;
  }

  .InputText_Main {
    flex: 1;
  }

  .InputText_PostUrl {
    font-size: 13px;
    font-weight: bold;
  }

  .InputText_Error {
    display: block;
    margin-top: 8px;
    color: ${constants.COLORS.cautionText};
    font-size: 14px;
  }
`

const DispayLanguageIdWrapper = styled.div`
  display: none;
`

export default AdminPickupNew
